module.exports = __webpack_public_path__ + "assets/img/3127c2f3cc4181e0958a440627a07ad5.png";